import React from 'react'

// Components
import Table from '../../_components/Table'
import { createColumn } from '../../_components/TableColumn'

// Constants

export const InvoicesTable = ({ invoices }) => {
  if (!invoices || invoices.length === 0) {
    return null
  }

  return (
    <Table
      columns={[
        {
          accessor: 'debtor_name',
          headingText: 'Debtor',
        },
        {
          accessor: 'invoice_number',
          headingText: 'Invoice #',
        },
        createColumn({
          type: 'date',
          id: 'invoice_date',
          headingText: 'Date',
        }),
        createColumn({
          type: 'currency',
          id: 'invoice_amount',
          headingText: 'Amount',
        }),
      ]}
      data={invoices}
    />
  )
}
